<style lang="css">

</style>

<template lang="html">
<!-- 设置action -->
<el-form v-form
    editAction="carShow/business/updateBusiness.action"
    addAction= "carShow/business/insertBusiness.action"
    selectAction="carShow/business/selectBusinessInfo.action"
    :model="carExhibitionBusinessForm" :rules="rules" label-width="120px">
    <el-form-item label="商家名称：" prop="name">
        <el-input v-model="carExhibitionBusinessForm.name" placeholder="比如：宝渝宝马4S店（巴南店）"></el-input>
    </el-form-item>
    <el-form-item label="商家性质：" prop="type">
      <el-select clearable v-model="carExhibitionBusinessForm.type" placeholder="请选择商家性质">
        <el-option label="4S店" value="4S店"></el-option>
        <el-option label="综合合伙人" value="综合合伙人"></el-option>
        <el-option label="直营店" value="直营店"></el-option>
        <el-option label="厂家" value="厂家"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="商家地址：" prop="address">
        <el-input v-model="carExhibitionBusinessForm.address" placeholder="请输入商家地址"></el-input>
    </el-form-item>
    <el-form-item label="对接人姓名：" prop="management">
        <el-input v-model="carExhibitionBusinessForm.management" placeholder="请输入对接人姓名">
        </el-input>
    </el-form-item>
    <el-form-item label="对接人电话：" prop="phone">
        <el-input v-model="carExhibitionBusinessForm.phone" type="number" placeholder="请输入对接人电话">
        </el-input>
        <div style="color:red;">将用于接收活动期间用户的电话咨询！</div>
    </el-form-item>
    <el-form-item label="上传封面图片：" prop="coverImage">
        <el-upload
          v-model="carExhibitionBusinessForm.coverImage"
          :action="baseUrl+'upload/uploadPic'"
          :data="{floder:'carExhibition'}"
          :show-file-list="false"
          class="avatar-uploader">
            <img v-if="carExhibitionBusinessForm.coverImage&&carExhibitionBusinessForm.coverImage.url" :src="carExhibitionBusinessForm.coverImage.url" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <div style="color:#999;">支持jpg、png图片格式，750*460px，<span style="color:red">最多1张</span></div>
    </el-form-item>
    <el-form-item label="上传更多图片：" prop="advertisementImage">
        <el-upload
            multiple
            :file-list="carExhibitionBusinessForm.advertisementImage"
            v-model="carExhibitionBusinessForm.advertisementImage"
            :action="baseUrl+'upload/uploadPic'"
            :data="{floder:'carExhibition'}"
            :limit="9"
            list-type="picture-card">
            <i class="el-icon-plus"></i>
        </el-upload>
        <div style="color:#999;">支持jpg、png图片格式，750*460px，<span style="color:red">最多9张，用于商家详情顶部展示！</span></div>
    </el-form-item>
    <el-form-item>
        <el-button type="primary">保存</el-button>
    </el-form-item>
</el-form>

</template>

<script>
import Config from '@/framework/configs/Config'
import BasicPager from '@/mixins/BasicPager'
export default {
  extends: BasicPager,
  data: function () {
    return {
      baseUrl: Config.baseUrl,
      carExhibitionBusinessForm: {
        id: null,
        advertisementImage: []
      },
      rules: {
        name: [
          { required: true, message: '请输入商家名称', trigger: 'blur' },
          { max: 50, message: '长度不能超过50个字', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择商家性质', trigger: 'change' }
        ],
        address: [
          { required: true, message: '请输入商家地址', trigger: 'blur' },
          { max: 200, message: '长度不能超过200个字', trigger: 'blur' }
        ],
        management: [
          { required: true, message: '请输入对接人姓名', trigger: 'blur' },
          { max: 20, message: '长度不能超过20个字', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入对接人电话', trigger: 'blur' },
          { max: 11, message: '电话不能超过11位', trigger: 'blur' }
        ],
        coverImage: [
          { required: true, message: '请上传封面图片', trigger: 'change' }
        ],
        advertisementImage: [
          { required: true, message: '请上传更多图片', trigger: 'change' }
        ]
      }
    }
  },
  created: function () {
    let params = this.$route.params

    if (params.carShowInfoId) {
      this.carExhibitionBusinessForm.carShowInfoId = params.carShowInfoId
      this.carExhibitionBusinessForm.createEmployee = this.loginInfo.realName
    }

    if (params.id) {
      this.carExhibitionBusinessForm.id = params.id
    }
  }
}

</script>
